// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".contrast .table-of-contents a.active[data-v-1ed0a80f],.contrast .table-of-contents a[data-v-1ed0a80f]:hover{border-left-color:#fff}", ""]);
// Exports
module.exports = exports;
